import React from 'react';

export const BlockLearningPreview = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'block-learning-preview' */
            './BlockLearningPreview'
        ),
);
